import React from "react"
import { SectionHeader } from "dash-styled"
import { FC } from "react"
import {
    AIModelForApp,
    getTotalPredictionCount
} from "../../../../../../../../Models/API/AIModel"
import { ActivityChart } from "./ActivityChart"

interface ActivitySectionProps {
    className?: string
    model: AIModelForApp
}

export const ActivitySection: FC<ActivitySectionProps> = ({
    className,
    model
}) => {
    return (
        <section className={className}>
            <SectionHeader>
                Predictions ({getTotalPredictionCount(model).toLocaleString()})
            </SectionHeader>
            <p className="text-rhino-800 my-2">Predictions in last week</p>
            <ActivityChart isSimple={false} model={model} />
        </section>
    )
}
